@keyframes tooltipTop {
  from {
    opacity: 0;
    transform: translate(-50%, calc(-100% - 8px));
  }

  to {
    opacity: 1;
    transform: translate(-50%, calc(-100% - 8px));
  }
}

@keyframes tooltipBottom {
  from {
    opacity: 0;
    transform: translate(-50%, 8px);
  }

  to {
    opacity: 1;
    transform: translate(-50%, 8px);
  }
}

@keyframes tooltipLeft {
  from {
    opacity: 0;
    transform: translate(calc(-100% - 8px), -50%);
  }

  to {
    opacity: 1;
    transform: translate(calc(-100% - 8px), -50%);
  }
}

@keyframes tooltipRight {
  from {
    opacity: 0;
    transform: translate(8px, -50%);
  }

  to {
    opacity: 1;
    transform: translate(8px, -50%);
  }
}

.RCTooltip {
  position: absolute;
  z-index: 9999;
  background: var(--base_color1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  padding: 14px;
  border-radius: 4px;
  pointer-events: none;
  width: max-content;
  max-width: 225px;

  font-size: 13px;
  color: var(--color_neutral_0);
  text-align: center;
  word-break: break-word;

  opacity: 0;
  visibility: hidden;

  &.visible {
    visibility: visible;
    pointer-events: auto;
    animation-duration: 0.3s;
    animation-fill-mode: forwards;
    animation-timing-function: cubic-bezier(0.74, -0.03, 0.05, 1.24);
  }

  &::before {
    content: '';
    display: block;
    position: absolute;
    z-index: 9999;
    width: 0;
    height: 0;
    pointer-events: none;
    border: 6px solid transparent;
  }

  &.top,
  &.tooltippedN {
    transform-origin: 50% 100%;

    &.visible {
      animation-name: tooltipTop;
    }

    &::before {
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      border-top-color: var(--base_color1);
    }
  }

  &.bottom,
  &.tooltippedS {
    transform-origin: 50% 0%;

    &.visible {
      animation-name: tooltipBottom;
    }

    &::before {
      bottom: 100%;
      left: 50%;
      transform: translateX(-50%);
      border-bottom-color: var(--base_color1);
    }
  }

  &.left,
  &.tooltippedW {
    transform-origin: 100% 50%;

    &.visible {
      animation-name: tooltipLeft;
    }

    &::before {
      top: 50%;
      left: 100%;
      transform: translateY(-50%);
      border-left-color: var(--base_color1);
    }
  }

  &.right,
  &.tooltippedE {
    transform-origin: 0% 50%;

    &.visible {
      animation-name: tooltipRight;
    }

    &::before {
      top: 50%;
      right: 100%;
      transform: translateY(-50%);
      border-right-color: var(--base_color1);
    }
  }
}
